module.exports = "<div ui-view>\n</div>\n"


/*****************
 ** WEBPACK FOOTER
 ** ../~/noop-loader!./components/xo-credit-components/src/bml-display/template.html
 ** module id = 462
 ** module chunks = 1
 **/